var ispwData = {
    "swagger":"2.0",
    "info":{
        "version":"20.5.1-SNAPSHOT",
        "title":"com.compuware.ispw.services.web"
    },
    "host":"localhost",
    "basePath":"/",
    "schemes":[
        "http",
        "https"
    ],
    "tags":[
        {
            "name":"assignments"
        },
        {
            "name":"build"
        },
        {
            "name":"commits"
        },
        {
            "name":"componentVersions"
        },
        {
            "name":"containers"
        },
        {
            "name":"deployments"
        },
        {
            "name":"promotionAnalysis"
        },
        {
            "name":"releases"
        },
        {
            "name":"sets"
        },
        {
            "name":"worklist"
        }
    ],
    "paths":{
        "/webhooks":{
            "put":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/HCIWebhookWrapper"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/WebhookTriggerResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "type":"string"
                        }
                    }
                }
            },
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/HCIWebhookWrapper"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "type":"string"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "type":"string"
                        }
                    }
                }
            }
        },
        "/{srid}/assignments":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/AssignmentInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "201":{
                        "description":"Created",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/build":{
            "post":{
            "summary":"Build an assignment. Load impacting tasks into an assignment and initiate a generate on them.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":false
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/BuildResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/build":{
            "post":{
            	"summary":"Load impacting tasks into an assignment and initiate a generate on them.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"application",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"query",
                        "required":false
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"array",
                        "items":{
                            "type":"string"
                        },
                        "name":"taskId",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"Build Initiated - the build has been started.",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/BuildResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "build"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/build":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":false
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"Build Initiated - the build has been started.",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/BuildResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/task/add":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"checkout",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/AddTaskInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AddTaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AddTaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AddTaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AddTaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AddTaskResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/taskIds/deploy":{
            "post":{
	            "summary":"Deploys tasks in an assignment. You may use task IDs to deploy specific tasks in that assignment.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"array",
                        "items":{
                            "type":"string"
                        },
                        "name":"taskId",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/DeployInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/taskIds/generate":{
            "post":{
                "summary":"Generates tasks in an assignment. You may use task IDs to generate specific tasks in that assignment.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"array",
                        "items":{
                            "type":"string"
                        },
                        "name":"taskId",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/deploy":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/DeployInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/generate":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/generations":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/promote":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/promotionAnalysis":{
            "post":{
            "summary":"Run promotion analysis on an Assignment. Checks whether all the tasks in the assignment are ready to be promoted.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                    	"description":"Promotion Analysis completed successfully",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/PromotionAnalysisResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/regress":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/transfer":{
            "post":{
                "summary":"Transfer one or more tasks from an assignment to another assignment or release",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/TransferTaskInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentid}":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentInfo"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentInfo"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentInfo"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentInfo"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentInfo"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentid}/cancel":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentid}/close":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/AssignmentResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentid}/tasks":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            },
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "type":"string"
                        }
                    },
                    "201":{
                        "description":"Created",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "type":"string"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "type":"string"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "type":"string"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "type":"string"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentid}/tasks/fallback":{
            "post":{
                "summary":"Fallback an assignment.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentid}/tasks/{taskid}":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"taskid",
                        "in":"path",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentid}/tasks/{taskid}/listing":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"taskid",
                        "in":"path",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    }
                },
                "tags":[
                    "assignments"
                ]
            }
        },
		"/{srid}/commits/{commitHash}/tasks/deploy":{
            "post":{
                "summary":"Deploys tasks based on a commit. You may use task IDs to deploy specific tasks within that commit.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"commitHash",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"array",
                        "items":{
                            "type":"string"
                        },
                        "name":"taskId",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/DeployInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "commits"
                ]
            }
        },
        "/{srid}/commits/{commitHash}/tasks/generate":{
            "post":{
                "summary":"Generates tasks based on a commit. You may use task IDs to generate specific tasks within that commit.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"commitHash",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"array",
                        "items":{
                            "type":"string"
                        },
                        "name":"taskId",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "commits"
                ]
            }
        },
        "/{srid}/componentVersions/list":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"application",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ComponentVersionsListResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ComponentVersionsListResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ComponentVersionsListResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ComponentVersionsListResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ComponentVersionsListResponse"
                        }
                    }
                },
                "tags":[
                    "componentVersions"
                ]
            }
        },
        "/{srid}/containers/list":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"application",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"containerId",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"array",
                        "items":{
                            "type":"string"
                        },
                        "name":"containerType",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"description",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"includeClosedContainers",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"owner",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"path",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"refNumber",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"stream",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"tag",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"userId",
                        "in":"query",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ContainerListResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ContainerListResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ContainerListResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ContainerListResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ContainerListResponse"
                        }
                    }
                },
                "tags":[
                    "containers"
                ]
            }
        },
        "/{srid}/deployments/{requestId}/cancel":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"integer",
                        "name":"requestId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        }
                    }
                },
                "tags":[
                    "deployments"
                ]
            }
        },
        "/{srid}/deployments/{requestId}/modify":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"integer",
                        "name":"requestId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/DeployModifyInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        }
                    }
                },
                "tags":[
                    "deployments"
                ]
            }
        },
        "/{srid}/promotionAnalysis":{
            "post":{
            	"summary":"Run promotion analysis on a task. Checks whether all the tasks provided are ready to be promoted.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"array",
                        "items":{
                            "type":"string"
                        },
                        "name":"taskId",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"Promotion Analysis completed successfully",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/PromotionAnalysisResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "promotionAnalysis"
                ]
            }
        },
        "/{srid}/releases":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/ReleaseInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/cancel":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/close":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/deploy":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/DeployInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeployResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/generate":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/generations":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/promote":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/promotionAnalysis":{
            "post":{
            "summary":"Run promotion analysis on a Release. Checks whether all the tasks in the release are ready to be promoted.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                    	"description":"Promotion Analysis completed successfully",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/PromotionAnalysisResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/regress":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/remove":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/MultiTaskInfoResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/{taskid}":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"taskid",
                        "in":"path",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskInfo"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/taskIds/deploy":{
            "post":{
	            "summary":"Deploys tasks in a release. You may use task IDs to generate specific tasks in that release.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"array",
                        "items":{
                            "type":"string"
                        },
                        "name":"taskId",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/DeployInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/taskIds/generate":{
            "post":{
	            "summary":"Generates tasks in a release. You may use task IDs to generate specific tasks in that release.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"array",
                        "items":{
                            "type":"string"
                        },
                        "name":"taskId",
                        "in":"query",
                        "required":false
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseid}":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseInfo"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseInfo"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseInfo"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseInfo"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/ReleaseInfo"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseid}/tasks/fallback":{
            "post":{
                "summary":"Fallback a release.",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseid}/tasks/{taskid}/listing":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"taskid",
                        "in":"path",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListingResponse"
                        }
                    }
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/sets/{setId}":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"setId",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/SetInfoResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/SetInfoResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/SetInfoResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/SetInfoResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/SetInfoResponse"
                        }
                    }
                },
                "tags":[
                    "sets"
                ]
            }
        },
        "/{srid}/sets/{setid}/deployment":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"setid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentInfoResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentInfoResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentInfoResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentInfoResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentInfoResponse"
                        }
                    }
                },
                "tags":[
                    "sets"
                ]
            }
        },
        "/{srid}/sets/{setid}/tasks":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"setid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskListResponse"
                        }
                    }
                },
                "tags":[
                    "sets"
                ]
            }
        },
        "/{srid}/sets/{setid}/tasks/fallback":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"setid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "sets"
                ]
            }
        },
        "/{srid}/sets/{setid}/{action}":{
            "post":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"action",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"setid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"approver",
                        "in":"query",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "sets"
                ]
            }
        },
        "/{srid}/worklist":{
            "get":{
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"application",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"endDate",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"environment",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"group",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"historical",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"inProgress",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"lastUpdatedBy",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"name",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"operation",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"owner",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"production",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"refNumber",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"startDate",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"stream",
                        "in":"query",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"type",
                        "in":"query",
                        "required":true
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/WorkListResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/WorkListResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/WorkListResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/WorkListResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/WorkListResponse"
                        }
                    }
                },
                "tags":[
                    "worklist"
                ]
            }
        }
    },
    "definitions":{
        "AddTaskInfo":{
            "properties":{
                "action":{
                    "type":"string"
                },
                "application":{
                    "type":"string"
                },
                "checkoutFromLevel":{
                    "type":"string"
                },
                "owner":{
                    "type":"string"
                },
                "path":{
                    "type":"string"
                },
                "releaseId":{
                    "type":"string"
                },
                "runtimeConfiguration":{
                    "type":"string"
                },
                "stream":{
                    "type":"string"
                },
                "taskName":{
                    "type":"string"
                },
                "type":{
                    "type":"string"
                }
            }
        },
        "AddTaskResponse":{
            "properties":{
                "message":{
                    "type":"string"
                },
                "setId":{
                    "type":"string"
                },
                "taskName":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "AssignmentInfo":{
            "properties":{
                "application":{
                    "type":"string"
                },
                "assignmentPrefix":{
                    "type":"string"
                },
                "defaultPath":{
                    "type":"string"
                },
                "description":{
                    "type":"string"
                },
                "message":{
                    "type":"string"
                },
                "owner":{
                    "type":"string"
                },
                "projectNumber":{
                    "type":"string"
                },
                "refNumber":{
                    "type":"string"
                },
                "release":{
                    "type":"string"
                },
                "stream":{
                    "type":"string"
                },
                "userTag":{
                    "type":"string"
                }
            }
        },
        "AssignmentResponse":{
            "properties":{
                "assignmentId":{
                    "type":"string"
                },
                "message":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "BasicAuthentication":{
            "properties":{
                "password":{
                    "type":"string"
                },
                "username":{
                    "type":"string"
                }
            }
        },
        "BuildResponse":{
            "properties":{
                "assignmentId":{
                    "type":"string"
                },
                "message":{
                    "type":"string"
                },
                "setId":{
                    "type":"string"
                },
                "tasks":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TaskInfo"
                    }
                },
                "url":{
                    "type":"string",
                    "description":"HTTP URL for the set."
                }
            }
        },
        "ComponentVersionsListInfo":{
            "properties":{
                "action":{
                    "type":"string"
                },
                "alternateName":{
                    "type":"string"
                },
                "application":{
                    "type":"string"
                },
                "assignmentId":{
                    "type":"string"
                },
                "baseVersion":{
                    "type":"integer"
                },
                "checkoutDateTime":{
                    "type":"string"
                },
                "dateTime":{
                    "type":"string"
                },
                "environment":{
                    "type":"string"
                },
                "internalVersion":{
                    "type":"integer"
                },
                "level":{
                    "type":"string"
                },
                "message":{
                    "type":"string"
                },
                "operation":{
                    "type":"string"
                },
                "owner":{
                    "type":"string"
                },
                "path":{
                    "type":"string"
                },
                "replaceVersion":{
                    "type":"integer"
                },
                "status":{
                    "type":"string"
                },
                "stream":{
                    "type":"string"
                },
                "userId":{
                    "type":"string"
                },
                "version":{
                    "type":"integer"
                }
            }
        },
        "ComponentVersionsListResponse":{
            "properties":{
                "componentVersionsList":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/ComponentVersionsListInfo"
                    }
                },
                "message":{
                    "type":"string"
                }
            }
        },
        "ContainerInfo":{
            "properties":{
                "application":{
                    "type":"string"
                },
                "containerId":{
                    "type":"string"
                },
                "containerType":{
                    "type":"string"
                },
                "description":{
                    "type":"string"
                },
                "owner":{
                    "type":"string"
                },
                "path":{
                    "type":"string"
                },
                "refNumber":{
                    "type":"string"
                },
                "releaseId":{
                    "type":"string"
                },
                "stream":{
                    "type":"string"
                },
                "tag":{
                    "type":"string"
                }
            }
        },
        "ContainerListResponse":{
            "properties":{
                "containers":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/ContainerInfo"
                    }
                },
                "message":{
                    "type":"string"
                }
            }
        },
        "DeployEnv":{
            "properties":{
                "deployActiveDate":{
                    "type":"string"
                },
                "deployActiveTime":{
                    "type":"string"
                },
                "deployImplementationDate":{
                    "type":"string"
                },
                "deployImplementationTime":{
                    "type":"string"
                },
                "events":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/EventCallback"
                    }
                },
                "hold":{
                    "type":"string"
                },
                "name":{
                    "type":"string"
                }
            }
        },
        "DeployEnvResponse":{
            "properties":{
                "name":{
                    "type":"string"
                },
                "requestId":{
                    "type":"string"
                }
            }
        },
        "DeployInfo":{
            "properties":{
                "autoDeploy":{
                    "type":"string"
                },
                "changeType":{
                    "type":"string"
                },
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication"
                },
                "deployActiveDate":{
                    "type":"string"
                },
                "deployActiveTime":{
                    "type":"string"
                },
                "deployEnvs":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeployEnv"
                    }
                },
                "deployImplementationDate":{
                    "type":"string"
                },
                "deployImplementationTime":{
                    "type":"string"
                },
                "dpenvlst":{
                    "type":"string"
                },
                "events":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/EventCallback"
                    }
                },
                "execStat":{
                    "type":"string"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    }
                },
                "runtimeConfig":{
                    "type":"string"
                },
                "system":{
                    "type":"string"
                },
                "taskId":{
                    "type":"string array"
                }
            }
        },
        "DeployModifyInfo":{
            "properties":{
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication"
                },
                "deployActiveDate":{
                    "type":"string"
                },
                "deployActiveTime":{
                    "type":"string"
                },
                "deployImplementationDate":{
                    "type":"string"
                },
                "deployImplementationTime":{
                    "type":"string"
                },
                "events":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/EventCallback"
                    }
                },
                "hold":{
                    "type":"string"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    }
                },
                "runtimeConfig":{
                    "type":"string"
                }
            }
        },
        "DeployResponse":{
            "properties":{
                "deployEnvResps":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeployEnvResponse"
                    }
                },
                "message":{
                    "type":"string"
                },
                "setId":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "DeploymentInfo":{
            "properties":{
                "createDate":{
                    "type":"string"
                },
                "description":{
                    "type":"string"
                },
                "environment":{
                    "type":"string"
                },
                "message":{
                    "type":"array",
                    "items":{
                        "type":"string"
                    }
                },
                "packages":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeploymentPackageInfo"
                    }
                },
                "requestId":{
                    "type":"string"
                },
                "setId":{
                    "type":"string"
                },
                "status":{
                    "type":"string"
                }
            }
        },
        "DeploymentInfoResponse":{
            "properties":{
                "deployments":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeploymentInfo"
                    }
                }
            }
        },
        "DeploymentPackageInfo":{
            "properties":{
                "activeDate":{
                    "type":"string"
                },
                "category":{
                    "type":"string"
                },
                "deploymentItems":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeploymentPackageItem"
                    }
                },
                "endDate":{
                    "type":"string"
                },
                "implementationDate":{
                    "type":"string"
                },
                "packageId":{
                    "type":"string"
                },
                "startDate":{
                    "type":"string"
                },
                "status":{
                    "type":"string"
                },
                "subEnvironment":{
                    "type":"string"
                },
                "system":{
                    "type":"string"
                }
            }
        },
        "DeploymentPackageItem":{
            "properties":{
                "action":{
                    "type":"string"
                },
                "application":{
                    "type":"string"
                },
                "clazz":{
                    "type":"string"
                },
                "deploymentType":{
                    "type":"string"
                },
                "item":{
                    "type":"string"
                },
                "name":{
                    "type":"string"
                },
                "part":{
                    "type":"string"
                },
                "status":{
                    "type":"string"
                },
                "storage":{
                    "type":"string"
                },
                "system":{
                    "type":"string"
                },
                "type":{
                    "type":"string"
                }
            }
        },
        "DeploymentResponse":{
            "properties":{
                "message":{
                    "type":"string"
                },
                "requestId":{
                    "type":"integer"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "EventCallback":{
            "properties":{
                "body":{
                    "type":"string"
                },
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    }
                },
                "method":{
                    "type":"string"
                },
                "name":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "HCIData":{
            "properties":{
                "host":{
                    "type":"string"
                },
                "key":{
                    "type":"string"
                },
                "port":{
                    "type":"integer"
                },
                "rtConfig":{
                    "type":"string"
                },
                "userName":{
                    "type":"string"
                },
                "value":{
                    "type":"string"
                }
            }
        },
        "HCIWebhookWrapper":{
            "properties":{
                "hciData":{
                    "$ref":"#/definitions/HCIData"
                },
                "webhook":{
                    "$ref":"#/definitions/Webhook"
                }
            }
        },
        "HttpHeader":{
            "properties":{
                "name":{
                    "type":"string"
                },
                "value":{
                    "type":"string"
                }
            }
        },
        "HttpRequest":{
            "properties":{
                "body":{
                    "type":"string"
                },
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    }
                },
                "method":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "MultiTaskFailure":{
            "properties":{
                "errorMessage":{
                    "type":"string"
                },
                "mname":{
                    "type":"string"
                },
                "mtype":{
                    "type":"string"
                },
                "taskId":{
                    "type":"string"
                }
            }
        },
        "MultiTaskInfoResponse":{
            "properties":{
                "failedTasks":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/MultiTaskFailure"
                    }
                },
                "message":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "PromotionAnalysisResponse":{
            "properties":{
                "numberOfErrors":{
                    "type":"integer"
                },
                "numberOfWarnings":{
                    "type":"integer"
                },
                "numberOfInfos":{
                    "type":"integer"
                },
                "timeOfAnalysis":{
                    "type":"string"
                },
                "containerId":{
                    "type":"string"
                },
                "numberOfTasksAnalyzed":{
                    "type":"integer"
                },
                "message":{
                	"type":"string"
                }
            }
        },
        "ReleaseInfo":{
            "properties":{
                "application":{
                    "type":"string"
                },
                "description":{
                    "type":"string"
                },
                "message":{
                    "type":"string"
                },
                "owner":{
                    "type":"string"
                },
                "releaseId":{
                    "type":"string"
                },
                "stream":{
                    "type":"string"
                },
                "userTag":{
                    "type":"string"
                }
            }
        },
        "ReleaseResponse":{
            "properties":{
                "message":{
                    "type":"string"
                },
                "releaseId":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "SetInfo":{
            "properties":{
                "autoDeploy":{
                    "type":"string"
                },
                "changeType":{
                    "type":"string"
                },
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication"
                },
                "deployActiveDate":{
                    "type":"string"
                },
                "deployActiveTime":{
                    "type":"string"
                },
                "deployImplementationDate":{
                    "type":"string"
                },
                "deployImplementationTime":{
                    "type":"string"
                },
                "dpenvlst":{
                    "type":"string"
                },
                "events":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/EventCallback"
                    }
                },
                "execStat":{
                    "type":"string"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    }
                },
                "override":{
                    "type":"string"
                },
                "runtimeConfig":{
                    "type":"string"
                },
                "system":{
                    "type":"string"
                },
                "taskId":{
                    "type":"string array"
                }
            }
        },
        "SetInfoResponse":{
            "properties":{
                "applicationId":{
                    "type":"string"
                },
                "deployActiveDate":{
                    "type":"string"
                },
                "deployActiveTime":{
                    "type":"string"
                },
                "deployImplementationDate":{
                    "type":"string"
                },
                "deployImplementationTime":{
                    "type":"string"
                },
                "description":{
                    "type":"string"
                },
                "message":{
                    "type":"string"
                },
                "owner":{
                    "type":"string"
                },
                "setid":{
                    "type":"string"
                },
                "startDate":{
                    "type":"string"
                },
                "startTime":{
                    "type":"string"
                },
                "state":{
                    "type":"string"
                },
                "streamName":{
                    "type":"string"
                },
                "tasks":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TaskInfo"
                    }
                }
            }
        },
        "TaskInfo":{
            "properties":{
                "action":{
                    "type":"string"
                },
                "alternateName":{
                    "type":"string"
                },
                "application":{
                    "type":"string"
                },
                "baseVersion":{
                    "type":"integer"
                },
                "cics":{
                    "type":"boolean"
                },
                "clazz":{
                    "type":"string"
                },
                "container":{
                    "type":"string"
                },
                "currentLevel":{
                    "type":"string"
                },
                "dateTime":{
                    "type":"string"
                },
                "environment":{
                    "type":"string"
                },
                "extension":{
                    "type":"string"
                },
                "flags":{
                    "type":"string"
                },
                "generateSequence":{
                    "type":"string"
                },
                "ims":{
                    "type":"boolean"
                },
                "internalVersion":{
                    "type":"integer"
                },
                "level":{
                    "type":"string"
                },
                "message":{
                    "type":"string"
                },
                "moduleName":{
                    "type":"string"
                },
                "moduleType":{
                    "type":"string"
                },
                "operation":{
                    "type":"string"
                },
                "option1":{
                    "type":"string"
                },
                "option2":{
                    "type":"string"
                },
                "option3":{
                    "type":"string"
                },
                "option4":{
                    "type":"string"
                },
                "option5":{
                    "type":"string"
                },
                "program":{
                    "type":"boolean"
                },
                "release":{
                    "type":"string"
                },
                "replaceVersion":{
                    "type":"integer"
                },
                "set":{
                    "type":"string"
                },
                "sql":{
                    "type":"boolean"
                },
                "startingLevel":{
                    "type":"string"
                },
                "status":{
                    "type":"string"
                },
                "stream":{
                    "type":"string"
                },
                "taskId":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                },
                "userId":{
                    "type":"string"
                },
                "version":{
                    "type":"integer"
                }
            }
        },
        "TaskListResponse":{
            "properties":{
                "message":{
                    "type":"string"
                },
                "tasks":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TaskInfo"
                    }
                }
            }
        },
        "TaskListingResponse":{
            "properties":{
                "listing":{
                    "type":"string"
                },
                "message":{
                    "type":"string"
                }
            }
        },
        "TaskResponse":{
            "properties":{
                "message":{
                    "type":"string"
                },
                "setId":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "TransferTaskInfo":{
            "properties":{
                "containerId":{
                    "type":"string"
                },
                "containerType":{
                    "type":"string"
                },
                "runtimeConfiguration":{
                    "type":"string"
                }
            }
        },
        "TriggerApplication":{
            "properties":{
                "application":{
                    "type":"string"
                },
                "triggerID":{
                    "type":"string"
                }
            }
        },
        "TriggerEventName":{
            "properties":{
                "eventName":{
                    "type":"string"
                },
                "triggerID":{
                    "type":"string"
                }
            }
        },
        "TriggerLevel":{
            "properties":{
                "level":{
                    "type":"string"
                },
                "triggerID":{
                    "type":"string"
                }
            }
        },
        "TriggerOperation":{
            "properties":{
                "operation":{
                    "type":"string"
                },
                "triggerID":{
                    "type":"string"
                }
            }
        },
        "Webhook":{
            "properties":{
                "enabled":{
                    "type":"boolean"
                },
                "id":{
                    "type":"string"
                },
                "name":{
                    "type":"string"
                },
                "product":{
                    "$ref":"#/definitions/WebhookProduct"
                },
                "request":{
                    "$ref":"#/definitions/HttpRequest"
                }
            }
        },
        "WebhookProduct":{
            "properties":{
                "instance":{
                    "type":"string"
                },
                "name":{
                    "type":"string"
                },
                "thirdPartyProductId":{
                    "type":"string"
                }
            }
        },
        "WebhookTriggerResponse":{
            "properties":{
                "notificationKey":{
                    "type":"string"
                },
                "triggerApplications":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TriggerApplication"
                    }
                },
                "triggerEventNames":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TriggerEventName"
                    }
                },
                "triggerLevels":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TriggerLevel"
                    }
                },
                "triggerOperations":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TriggerOperation"
                    }
                },
                "webhook":{
                    "$ref":"#/definitions/Webhook"
                }
            }
        },
        "WorkListInfo":{
            "properties":{
                "action":{
                    "type":"string"
                },
                "alternateName":{
                    "type":"string"
                },
                "application":{
                    "type":"string"
                },
                "assignmentId":{
                    "type":"string"
                },
                "clazz":{
                    "type":"string"
                },
                "dateTime":{
                    "type":"string"
                },
                "environment":{
                    "type":"string"
                },
                "group":{
                    "type":"string"
                },
                "level":{
                    "type":"string"
                },
                "message":{
                    "type":"string"
                },
                "name":{
                    "type":"string"
                },
                "operation":{
                    "type":"string"
                },
                "owner":{
                    "type":"string"
                },
                "path":{
                    "type":"string"
                },
                "refNumber":{
                    "type":"string"
                },
                "relativePath":{
                    "type":"string"
                },
                "releaseId":{
                    "type":"string"
                },
                "stream":{
                    "type":"string"
                },
                "taskId":{
                    "type":"string"
                },
                "technology":{
                    "type":"string"
                },
                "type":{
                    "type":"string"
                },
                "user":{
                    "type":"string"
                },
                "version":{
                    "type":"integer"
                }
            }
        },
        "WorkListResponse":{
            "properties":{
                "message":{
                    "type":"string"
                },
                "workListItems":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/WorkListInfo"
                    }
                }
            }
        }
    }
}